// extracted by mini-css-extract-plugin
export var active = "_bc-7";
export var container = "_bc-0";
export var evenWidth = "_bc-4";
export var large = "_bc-5";
export var outlet = "_bc-8";
export var slide = "_bc-2";
export var small = "_bc-6";
export var tab = "_bc-3";
export var tabs = "_bc-1";